
const formatCurrency = (value, code = 'GBP') => {
    const codes = {
        'GBP': '£',
        'USD': '$',
    };
    if (value === undefined || value === null) return '';
    const amount = parseFloat(value);
    return `${codes[code]}${amount.toFixed(2)}`;
};

export default formatCurrency;
